import React from 'react';
import { useMediaQuery } from 'react-responsive';

import { MOBILE } from 'settings/mediaQuery';
import LoginAdminDesktop from '../LoginAdmin/LoginAdminDesktop/LoginAdminDesktop';
import LoginAdminMobile from '../LoginAdmin/LoginAdminMobile/LoginAdminMobile';

import styles from './LoginPage.module.scss';

function LoginPage(): JSX.Element {
  const isMobileAndPortraitTablet = useMediaQuery({
    query: MOBILE,
  });

  return (
    <div className={styles.container}>
      {!isMobileAndPortraitTablet && <LoginAdminDesktop />}
      {isMobileAndPortraitTablet && <LoginAdminMobile />}
    </div>
  );
}

export default LoginPage;
